import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Trash2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export default function MessagesTab() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/messages").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const act = async (fn, msg) => {
    try { await fn(); if (msg) toast.success(msg); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  if (!rows.length) return <p className="mt-6 text-slate-500" data-testid="messages-empty">No messages yet. Customers can write to you from the Contact page.</p>;
  return (
    <div className="mt-4 space-y-3" data-testid="messages-tab">
      {rows.map((m) => (
        <div key={m.id} className={`rounded-2xl border p-5 ${m.read ? "bg-white border-[#EDE4D3]" : "bg-[#FFF8EC] border-[#D4AF37]"}`} data-testid={`message-${m.id}`}>
          <div className="flex flex-wrap items-center gap-3">
            {!m.read && <span className="text-[10px] font-bold uppercase rounded-full bg-[#8C2220] text-white px-2 py-0.5" data-testid={`message-new-${m.id}`}>New</span>}
            <p className="font-semibold">{m.name} <span className="font-normal text-slate-500">· {m.email}</span></p>
            <span className="ml-auto text-xs text-slate-500">{new Date(m.created_at).toLocaleString("en-GB")}</span>
          </div>
          {m.subject && <p className="mt-2 font-medium">{m.subject}</p>}
          <p className="mt-2 text-sm text-slate-700 whitespace-pre-line">{m.message}</p>
          <div className="mt-4 flex flex-wrap gap-2">
            <a href={`mailto:${m.email}?subject=${encodeURIComponent("Re: " + (m.subject || "Your message to Albion Pantry"))}`} onClick={() => !m.read && act(() => api.post(`/admin/messages/${m.id}/read`))} className="rounded-full bg-[#1B3626] text-white px-4 py-1.5 text-sm flex items-center gap-2" data-testid={`message-reply-${m.id}`}><Mail className="w-4 h-4" /> Reply</a>
            {!m.read && <button onClick={() => act(() => api.post(`/admin/messages/${m.id}/read`), "Marked as read")} className="rounded-full border px-4 py-1.5 text-sm" data-testid={`message-read-${m.id}`}>Mark read</button>}
            <button onClick={() => window.confirm("Delete this message?") && act(() => api.delete(`/admin/messages/${m.id}`), "Message deleted")} className="rounded-full border border-rose-300 text-rose-700 px-4 py-1.5 text-sm flex items-center gap-1 ml-auto" data-testid={`message-delete-${m.id}`}><Trash2 className="w-4 h-4" /> Delete</button>
          </div>
        </div>
      ))}
    </div>
  );
}
